import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=30b5778c&scoped=true&"
import script from "./addressList.vue?vue&type=script&lang=js&"
export * from "./addressList.vue?vue&type=script&lang=js&"
import style0 from "./addressList.vue?vue&type=style&index=0&id=30b5778c&prod&lang=scss&"
import style1 from "./addressList.vue?vue&type=style&index=1&id=30b5778c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b5778c",
  null
  
)

export default component.exports